import { render, staticRenderFns } from "./LandPagePartner.vue?vue&type=template&id=6ad6055b&scoped=true&"
import script from "./LandPagePartner.vue?vue&type=script&lang=js&"
export * from "./LandPagePartner.vue?vue&type=script&lang=js&"
import style0 from "./LandPagePartner.vue?vue&type=style&index=0&id=6ad6055b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6055b",
  null
  
)

export default component.exports